/**
 * Created by jv on 01/03/2017.
 */
//js
const Shared = require("Sources/shared");
const LanguageManager = require("Sources/services/languagemanager");

//styles
require("Styles/pages/errors/404.scss");

$(function()
{
  LanguageManager.init(function()
  {

  }, Shared.defaultLocale);
});



// WEBPACK FOOTER //
// ./app/js/entries/errors/404.js